/**
 * Barrel file for enemy archetype configs.
 * To add a new archetype: create {id}.json, import it here, add to the array.
 */
import type { EnemyArchetypeConfig } from '../../utils/Types';

import grunt from './grunt.json';
import rusher from './rusher.json';
import heavy from './heavy.json';
import ranged from './ranged.json';
import shield from './shield.json';
import conductor from './conductor.json';
import patrol from './patrol.json';
import officer from './officer.json';

export const archetypes: EnemyArchetypeConfig[] = [
  grunt as EnemyArchetypeConfig,
  rusher as EnemyArchetypeConfig,
  heavy as EnemyArchetypeConfig,
  ranged as EnemyArchetypeConfig,
  shield as EnemyArchetypeConfig,
  conductor as EnemyArchetypeConfig,
  patrol as EnemyArchetypeConfig,
  officer as EnemyArchetypeConfig,
];
